import styled from 'styled-components';
import { Search as SearchIcon } from '@components/Icons';

const StyledSearchIcon = styled(SearchIcon)`
  position: relative;
  top: ${({ theme }) => theme.spacing(2)};
`;

export default StyledSearchIcon;
